import {Injectable} from "@angular/core";
import {ConfigColumn, ConfigColumnDefaultValue} from "../../_typing/config/config-column";
import {ModelID} from "../../_typing/generic-types";
import {map} from "rxjs/operators";
import {isComponent, isComponentArray} from "../../_models/component";
import {ComponentDataService} from "../../data/component-data.service";
import {ConfigStub} from "../../_typing/config-stub";
import {Observable, of} from "rxjs";

@Injectable({
    providedIn: 'root'
})
export class DefaultValueService {
    constructor(private componentDataService: ComponentDataService) {
    }

    cleanDefaultComponents(defaultField: ConfigColumn): Observable<ConfigColumnDefaultValue> {
        if (!defaultField.default_value) {
            return of(defaultField.default_value);
        }
        return this._checkComponents(defaultField.default_value);
    }

    private _checkComponents(defaultValue: ConfigColumnDefaultValue): Observable<ConfigColumnDefaultValue> {
        let componentIds: ModelID[];
        if (isComponentArray(defaultValue)) {
            componentIds = defaultValue.map(c => c.id);
        } else if (isComponent(defaultValue)) {
            componentIds = [defaultValue.id]
        }

        if(!componentIds.length) return of(defaultValue);

        return this.componentDataService.getComponents(componentIds).pipe(map(result => {
            if (isComponentArray(defaultValue)) {
                defaultValue = result?.data?.map(component => new ConfigStub(component));
            } else if (isComponent(defaultValue)) {
                defaultValue = result?.data?.[0] ? new ConfigStub(result.data[0]) : null;
            }
            return defaultValue;
        }))
    }


}
